import { render } from "./QuestionTypeForm.vue?vue&type=template&id=69f42329"
import script from "./QuestionTypeForm.vue?vue&type=script&lang=js"
export * from "./QuestionTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__